import {DB_TB_SALA_RESIGN} from "./lib/api/api_response_type";
import {exceljsUtils} from "./common";
import exceljs from "exceljs";
const salaryDataSheetName = ["諸ﾃﾞｰﾀ","諸データ"];
const salaryDataOriginValue = "個人コード";
type IcolnumnameChkData= Array<string|number|null|Array<string|number|null>>;
const columnName:{[key:string]:IcolnumnameChkData} = {
    USERID:[1,null,null,"個人コード"],
    FROMAT_P1_3_nr:[null,null,null,"P3以下通常"],
    FROMAT_P1_3_un:[null,null,null,"P3以下出張不可"],
    FROMAT_P1_3_fs:[null,null,null,"P3以下　初任給引上げによる引上げ調整あり"],
    FORMAT_S4M1_nc:[null,null,null,"S4M1カットなし"],
    FORMAT_S4M1_ct:[null,null,null,"S4M1カットあり"],
    FORMAT_M2M3:[null,null,null,"M2M3"],
    FORMAT_S3:[null,null,null,"使用書式"],
    JOB_LEVEL:[null,null,null,"資格等級"],
    BF_JOB_CLASS:[null,"昇給前",null,"号俸"],
    JOB_CLASS:[null,"昇給後",null,"号俸"],
    BF_BASE_SALARY:[null,"昇給前",null,"役割給"],
    CUT_RATE:[null,null,null,"カット率"],
    BASE_SALARY:[null,"昇給後","カット前","役割給"],
    CONTIN_REWARD:[null,"昇給後","カット前","勤続給"],
    MANAGE_REWARD:[null,"昇給後","カット前","マネジ手当"],
    WORK_REWARD:[null,"昇給後","カット前","業務手当"],
    CLASS_REWARD:[null,"昇給後","カット前","系統手当"],
    UNTRIP_DECREASE:[null,"昇給後","出張不可対象者役割給","減額分"],
    ADJ_PIT:[null,null,null,"調整号俸ピッチ"],
    ADJ_NUM:[null,null,null,"調整による昇給金額"],
    U_GOBO:[null,null,null,"号俸　従来の人事制度上の昇給分"]
}
interface IgetColumnNameCol{
    USERID:number,
    FROMAT:{1:number,2:number,3:number,4:number,5:number,6:number,7:number},
    JOB_LEVEL:number,
    BF_JOB_CLASS:number,
    JOB_CLASS:number,
    BF_BASE_SALARY:number,
    CUT_RATE:number,
    BASE_SALARY:number,
    CONTIN_REWARD:number,
    MANAGE_REWARD:number,
    WORK_REWARD:number,
    CLASS_REWARD:number,
    UNTRIP_DECREASE:number,
    ADJ_PIT:number,
    ADJ_NUM:number,
    U_GOBO:number,
}
export const importSalaryResign = (wb:exceljs.Workbook)=>{
    const data = [] as Array<DB_TB_SALA_RESIGN>;
    const dataSheet = slectSheet(wb);
    if(!dataSheet){
        return;
    }
    const originCoor = getOriginCell(dataSheet);
    if(!originCoor){
        return;
    }
    const column = getColumnNameCol(dataSheet,originCoor[0]);
    if(!column){
        return;
    }
    let row = originCoor[0]+1;
    const originX = originCoor[1];
    while(dataSheet.getRow(row).getCell(originX).text){
        const _row = dataSheet.getRow(row);
        data.push({
            "ADATE":"",
            "ADJ_NUM":cellToNum(_row.getCell(column.ADJ_NUM))??0,
            "ADJ_PIT":cellToNum(_row.getCell(column.ADJ_PIT))??0,
            "BASE_SALARY":cellToNum(_row.getCell(column.BASE_SALARY))??0,
            "BF_BASE_SALARY":cellToNum(_row.getCell(column.BF_BASE_SALARY))??0,
            "BF_JOB_CLASS":cellToNum(_row.getCell(column.BF_JOB_CLASS))??0,
            "CLASS_REWARD":cellToNum(_row.getCell(column.CLASS_REWARD))??0,
            "CONTIN_REWARD":cellToNum(_row.getCell(column.CONTIN_REWARD))??0,
            "CUT_RATE":cellToNum(_row.getCell(column.CUT_RATE))??0,
            "FROMAT":getFormatType(_row,column),
            "JOB_CLASS":cellToNum(_row.getCell(column.JOB_CLASS))??0,
            "JOB_LEVEL":_row.getCell(column.JOB_LEVEL).text,
            "MANAGE_REWARD":cellToNum(_row.getCell(column.MANAGE_REWARD))??0,
            "RDATE":"",
            "UNTRIP_DECREASE":cellToNum(_row.getCell(column.UNTRIP_DECREASE))??0,
            "USERID":_row.getCell(column.USERID).text,
            "WORK_REWARD":cellToNum(_row.getCell(column.WORK_REWARD))??0,
            "U_GOBO":cellToNum(_row.getCell(column.U_GOBO))??0,
        });
        row++;
    }
    return data;
}
const slectSheet  = (wb:exceljs.Workbook)=>{
    for(const sheet of wb.worksheets){
        if(salaryDataSheetName.includes(sheet.name)){
            if((sheet.getRow(1).getCell("B")).text === "1"){
                return sheet;
            }
        }
    }
    return;
}
const getOriginCell  = (ws:exceljs.Worksheet)=>{
    const startColumn = ((row:exceljs.Row)=>{
        for(let i=1;i<10;i++){
            if(row.getCell(i).text.length>0){
                return i;
            }
        }
        return;
    })(ws.getRow(1));
    if(!startColumn){
        return;
    }
    for(let i=1;i<10;i++){
        if(ws.getRow(i).getCell(startColumn).text === salaryDataOriginValue){
            return [i,startColumn];
        }
    }
    return;
}
const getColumnNameCol = (ws:exceljs.Worksheet,rowLnegth:number) => {
    const _ = {} as IgetColumnNameCol;
    const rows = ws.getRows(1,rowLnegth);
    if(!rows){
        return;
    }
    const columns = _getColumn(rows);
    const flags = [] as boolean[];
    _.USERID = _chkColumn(columns,columnName.USERID)||flags.push(false);
    _.FROMAT = {
        1:_chkColumn(columns,columnName.FROMAT_P1_3_nr)||flags.push(false),
        2:_chkColumn(columns,columnName.FROMAT_P1_3_un)||flags.push(false),
        3:_chkColumn(columns,columnName.FROMAT_P1_3_fs)||flags.push(false),
        4:_chkColumn(columns,columnName.FORMAT_S4M1_nc)||flags.push(false),
        5:_chkColumn(columns,columnName.FORMAT_S4M1_ct)||flags.push(false),
        6:_chkColumn(columns,columnName.FORMAT_M2M3)||flags.push(false),
        7:_chkColumn(columns,columnName.FORMAT_S3)||flags.push(false),
    }
    _.ADJ_NUM = _chkColumn(columns,columnName.ADJ_NUM)||flags.push(false);
    _.ADJ_PIT = _chkColumn(columns,columnName.ADJ_PIT)||flags.push(false);
    _.BASE_SALARY = _chkColumn(columns,columnName.BASE_SALARY)||flags.push(false);
    _.BF_BASE_SALARY = _chkColumn(columns,columnName.BF_BASE_SALARY)||flags.push(false);
    _.BF_JOB_CLASS  = _chkColumn(columns,columnName.BF_JOB_CLASS)||flags.push(false);
    _.CLASS_REWARD = _chkColumn(columns,columnName.CLASS_REWARD)||flags.push(false);
    _.CONTIN_REWARD = _chkColumn(columns,columnName.CONTIN_REWARD)||flags.push(false);
    _.CUT_RATE = _chkColumn(columns,columnName.CUT_RATE)||flags.push(false);
    _.JOB_CLASS = _chkColumn(columns,columnName.JOB_CLASS)||flags.push(false);
    _.JOB_LEVEL = _chkColumn(columns,columnName.JOB_LEVEL)||flags.push(false);
    _.MANAGE_REWARD = _chkColumn(columns,columnName.MANAGE_REWARD)||flags.push(false);
    _.UNTRIP_DECREASE = _chkColumn(columns,columnName.UNTRIP_DECREASE)||flags.push(false);
    _.WORK_REWARD = _chkColumn(columns,columnName.WORK_REWARD)||flags.push(false);
    _.U_GOBO  = _chkColumn(columns,columnName.U_GOBO)||flags.push(false);
    if(flags.includes(false)){
        return;
    }
    return _;
}
const _getColumn = (rows:exceljs.Row[]) =>{
    let maxCol = 0;
    const _ = [] as Array<number|string|null>[];
    for(const row of rows){
        const cel = exceljsUtils.getCells(row);
        for(const c of cel){
            maxCol = maxCol<parseInt(c.col,10)?parseInt(c.col,10):maxCol;
        }
    }
    for(let i=1;i<=maxCol;i++){
        const cells = exceljsUtils.getColumns(rows,i);
        _.push(cells.map((v)=>{
            if(v.type === exceljs.ValueType.Null){
                return null;
            }
            if(v.type === exceljs.ValueType.Number){
                return v.value as number;
            }
            return v.text;
        }))
    }
    return _;
}
const _chkColumn = (columns:Array<number|string|null>[],tgt:IcolnumnameChkData)=>{
    let _=0;
    for(const col of columns){
        _++;
        if(tgt.every((v,i)=>{
            if(v===null){
                return true;
            }
            if(Array.isArray(v)){
                if(v.includes(col[i])){
                    return true;
                }
            }else{
                if(v===col[i]){
                    return true;
                }
            }
            return false;
        })){
            return _;
        }
    }
    return;
}

const getFormatType = (row:exceljs.Row,columns:IgetColumnNameCol):number =>{
    if(row.getCell(columns.FROMAT[7]).value){
        const setFormat = row.getCell(columns.FROMAT[7]).value;
        if(typeof setFormat === "number"){
            return setFormat;
        }
        return 7;
    }
    if(row.getCell(columns.FROMAT[1]).value){
        return 1;
    }
    if(row.getCell(columns.FROMAT[2]).value){
        return 2;
    }
    if(row.getCell(columns.FROMAT[3]).value){
        return 3;
    }
    if(row.getCell(columns.FROMAT[4]).value){
        return 4;
    }
    if(row.getCell(columns.FROMAT[5]).value){
        return 5;
    }
    if(row.getCell(columns.FROMAT[6]).value){
        return 6;
    }
    return 0;
}

const cellToNum = (cell:exceljs.Cell) => {
    if(typeof cell.value === "number" && !isNaN(cell.value)){
        return cell.value
    }
    const _toNum = parseFloat(cell.text);
    if(!isNaN(_toNum)){
        return _toNum;
    }
    return;
}